import React, { useEffect, useState } from 'react';
import '../Custom/CustomApplicationConfiguration';
import { App, main } from '@configuratorware/configurator-frontendgui/App';

import once from 'lodash/once';

const mainOnlyOnce = once(async () => {
  return await main();
});

const AuthenticatedScreen = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      await mainOnlyOnce();
      setIsInitialized(true);
    };

    initialize();
  }, []);

  if (!isInitialized) {
    return null;
  }

  return <App />;
};

export default AuthenticatedScreen;
